export const apiBase = process.env.REACT_APP_API_BASE_URL || '/api';
export const authTokenStorageKey = 'iit-auth-token';
export const themeStorageKey = 'iit-theme';
export const themeOptions = [
  { id: 'default', labelKey: 'theme.default', label: '默认深灰', accent: '#38bdf8' },
  { id: 'bloomberg', labelKey: 'theme.bloomberg', label: 'Bloomberg', accent: '#f59e0b' },
  { id: 'cool-gray', labelKey: 'theme.coolGray', label: 'Cool Gray', accent: '#94a3b8' },
];
